<p class="fms-notification-title" *ngIf="title">{{ title }}</p>
<p class="fms-notification-body" *ngIf="body">{{ body }}</p>
